<template>
  <div>
    <header class="ailogoheader">

      <div class="header_left">
        <a href="/" target="_black" class="header_left_logo">
          <img alt="logo" src="@a/ailogo/images/logo.png" width="110" height="32"/>
        </a>
        <div class="header_left_nav">
          <div class="left_nav_title">
            <span class="iconfont icon-chuangzuozhezhongxin"></span>LOGO创作<img alt="logo" src="@a/ailogo/images/sv15on.svg"/>
          </div>
          <div class="nav_list_down">
            <div class="list_down_padding">
              <a href="https://www.ai-dog.net/product/article.html" target="_blank" class="list_down_li">
                <div class="down_li_icon"><img src="https://www.ai-dog.net/skin/images/sv16.svg"></div>
                <div class="down_li_title">
                  <div class="li_title_dd">软文写作</div>
                  <div class="li_title_dt">基于人工智能创作、海量创作高质量软文</div>
                </div>
              </a>
              <a href="https://www.ai-dog.net/member/#/aicompany/CompanyHome/CompanyHome" target="_blank"
                 class="list_down_li">
                <div class="down_li_icon"><img src="https://www.ai-dog.net/skin/images/sv26.svg"></div>
                <div class="down_li_title">
                  <div class="li_title_dd">AI公司起名</div>
                  <div class="li_title_dt">几秒内即可创建多个公司名称+查重</div>
                </div>
              </a>
              <a href="https://www.ai-dog.net/product/copywriting.html" target="_blank" class="list_down_li">
                <div class="down_li_icon"><img src="https://www.ai-dog.net/skin/images/sv17.svg"></div>
                <div class="down_li_title">
                  <div class="li_title_dd">文案创作</div>
                  <div class="li_title_dt">不再苦于写作，让AI帮你实现创意</div>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div class="header_left_link">
          <a href="https://www.ai-dog.net/ai-logo/home/" target="_blank">首页</a>
          <a href="https://www.ai-dog.net/help/ailogo/20.html" target="_blank">帮助中心</a>
        </div>
      </div>

      <div class="header_right">
        <!--        <div class="header_right_top">
          <div class="right_top_img">
            <img alt="logo" src="@a/ailogo/images/bg2.jpg" width="40" height="40" />
          </div>
          <div class="right_top_title font16">
            189****2147<span class="iconfont font14">&#xe6b3;</span>
          </div>
        </div>-->
        <div class="Header_right notLogin" v-if="!this.$store.getters.isLogin" @click="toLogin">
          <div class="notLogin_icon"><img src="@a/img/sv29.svg"/></div>
          <div class="notLogin_right">
            <router-link to="/login" class="notLogin_right_btn">登录</router-link>
          </div>
        </div>
        <div class="mockLoginSign" v-show="this.$store.state.IsMockLogin">当前为模拟登录用户账号，请不要做数据操作！</div>
        <div class="Header_right" v-if="this.$store.getters.isLogin">
          <!-- <a href="https://www.ai-dog.net/download/index.html" target="_blank" class="download">下载客户端</a> -->
          <div class="Header_right_con">
            <div class="Header_right_avatar"><img :src="this.baseURL + $store.getters.memberInfo.avatar"/></div>
            <div class="Header_right_txt">
              <div class="right_txt_title">{{ $store.getters.memberInfo.name }}<i class="el-icon-arrow-down"></i></div>
              <div class="WPCenter">
                <div class="WPCenter_content">
                  <div class="WPCenter_top">
                    <div class="WPCenter_top_user">
                      <div class="top_user_left"><img :src="this.baseURL + $store.getters.memberInfo.avatar"/></div>
                      <div class="top_user_right">
                        <div class="user_right_dd">{{ $store.getters.memberInfo.name }}</div>
                        <div class="user_right_dt">{{ $store.getters.memberInfo.phone }}</div>
                      </div>
                    </div>
                    <div class="WPCenter_top_bottom">
                      <div class="top_bottom_dd">剩余创作次数：{{ $store.getters.memberInfo.logo_num }}</div>
                      <div @click="showWindow" class="top_bottom_dt">充值</div>
                    </div>
                  </div>
                  <div class="WPCenter_bottom">
                    <!-- <router-link to="/ailogo/LogoCenter/FreeCreationCenter" class="WPCenter_bottom_list"><i
                        class="el-icon-user"></i>个人中心
                    </router-link> -->
                    <router-link to="/ailogo/LogoCenter/FreeCreationCenter" class="WPCenter_bottom_list"><img
                        src="@a/ailogo/images/sv16.svg"/>LOGO记录
                    </router-link>
                    <div class="WPCenter_bottom_list" @click="RechargeRecordShow = !RechargeRecordShow"><img
                        src="@a/ailogo/images/sv17.svg"/>充值记录
                    </div>
                    <a href="https://affim.baidu.com/unique_57216128/chat?siteId=21467967&userId=57216128&siteToken=9f9b60f596a10c1b494ba79f8f356e69&cp=&cr=&cw=AI%E5%85%AC%E5%8F%B8%E8%B5%B7%E5%90%8D%E6%95%B0%E5%AD%97%E8%B5%84%E4%BA%A7%E5%8C%85%E8%B4%AD%E4%B9%B0%E5%92%A8%E8%AF%A2" 
                    target="_blank"
                    class="WPCenter_bottom_list"><img
                        src="@a/ailogo/images/sv18.svg"/>联系客服
                    </a>
                    <!-- <div class="WPCenter_bottom_list"><i class="el-icon-bell"></i>我的消息</div> -->
                    <div class="WPCenter_bottom_list" @click="logout"><i class="el-icon-switch-button"></i>退出登录
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>


    <div class="ailogoNav">
      <div class="ailogoNav_left">
        <!-- 左侧导航链接 -->
        <router-link v-for="link in leftLinks" :key="link.to" :to="link.to"
                     :class="['ailogoNav_left_list', { 'active-link': isLeftLinkActive(link) }]">
          <div class="left_list_dd">
            <span>
              <img :alt="link.alt" :src="isLeftLinkActive(link) ? link.iconActive : link.icon"/>
            </span>
          </div>
          <div class="left_list_dt">
            {{ link.baseText }}<span v-if="link.count">({{ link.count }})</span>
          </div>
        </router-link>
      </div>
      <div class="ailogoNav_right">
        <!-- 右侧导航链接，根据当前左侧导航项动态渲染 -->
        <div class="GenerateManagementNav_logo2" v-if="ClickLogoShow">
          <div class="GenerateManagementNav_logo_img">
            <img alt="" src="@a/ailogo/images/bg12.jpg"/>
          </div>
          <div class="GenerateManagementNav_logo_btn" @click="GenerateManagementWindowClass">
            <span><img alt="" src="@a/ailogo/images/sv4on.svg"/></span>切换LOGO
          </div>
        </div>

        <div class="ailogoNav_right_list" v-if="currentLeftLink" v-for="group in currentLeftLink.rightGroups"
             :key="group.id">
          <router-link v-for="link in group.links" :key="link.to" :to="link.to"
                       :class="['right_list_li', { 'active-link': isActive(link) }]">
            <div class="list_li_title">
              <div class="li_title_icon">
                <span>
                  <img :alt="link.alt" :src="isActive(link) ? link.iconActive : link.icon"/>
                </span>
              </div>
              <div class="li_title_title">
                {{ link.baseText }}<span v-if="link.count">({{ link.count }})</span>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>


    <!-- logo切换弹窗 -->
    <div class="GenerateManagement_Window" :class="{ active: GenerateManagementWindowActive }">
      <div class="GenerateManagement_Window_content">
        <div class="Window_content_title font18">
          选择我的LOGO
          <div class="content_title_back" @click="GenerateManagementWindowClass">
            <img alt="" src="@a/ailogo/images/sv15.svg"/>
          </div>
        </div>
        <div class="Window_content_txt OScroll">
          <div class="content_txt_list active">
            <div class="txt_list_now font14">当前</div>
            <div class="txt_list_img"><img alt="" src="@a/ailogo/images/bg12.jpg"/></div>
            <div class="txt_list_btn font14">切换LOGO</div>
          </div>
          <div class="content_txt_list">
            <div class="txt_list_now font14">当前</div>
            <div class="txt_list_img"><img alt="" src="@a/ailogo/images/bg12.jpg"/></div>
            <div class="txt_list_btn font14">切换LOGO</div>
          </div>
          <div class="content_txt_list">
            <div class="txt_list_now font14">当前</div>
            <div class="txt_list_img"><img alt="" src="@a/ailogo/images/bg12.jpg"/></div>
            <div class="txt_list_btn font14">切换LOGO</div>
          </div>
          <div class="content_txt_list">
            <div class="txt_list_now font14">当前</div>
            <div class="txt_list_img"><img alt="" src="@a/ailogo/images/bg12.jpg"/></div>
            <div class="txt_list_btn font14">切换LOGO</div>
          </div>
          <div class="content_txt_list">
            <div class="txt_list_now font14">当前</div>
            <div class="txt_list_img"><img alt="" src="@a/ailogo/images/bg12.jpg"/></div>
            <div class="txt_list_btn font14">切换LOGO</div>
          </div>
          <div class="content_txt_list">
            <div class="txt_list_now font14">当前</div>
            <div class="txt_list_img"><img alt="" src="@a/ailogo/images/bg12.jpg"/></div>
            <div class="txt_list_btn font14">切换LOGO</div>
          </div>
          <div class="content_txt_list">
            <div class="txt_list_now font14">当前</div>
            <div class="txt_list_img"><img alt="" src="@a/ailogo/images/bg12.jpg"/></div>
            <div class="txt_list_btn font14">切换LOGO</div>
          </div>
          <div class="content_txt_list">
            <div class="txt_list_now font14">当前</div>
            <div class="txt_list_img"><img alt="" src="@a/ailogo/images/bg12.jpg"/></div>
            <div class="txt_list_btn font14">切换LOGO</div>
          </div>
          <div class="content_txt_list">
            <div class="txt_list_now font14">当前</div>
            <div class="txt_list_img"><img alt="" src="@a/ailogo/images/bg12.jpg"/></div>
            <div class="txt_list_btn font14">切换LOGO</div>
          </div>
          <div class="content_txt_list">
            <div class="txt_list_now font14">当前</div>
            <div class="txt_list_img"><img alt="" src="@a/ailogo/images/bg12.jpg"/></div>
            <div class="txt_list_btn font14">切换LOGO</div>
          </div>
          <div class="content_txt_list">
            <div class="txt_list_now font14">当前</div>
            <div class="txt_list_img"><img alt="" src="@a/ailogo/images/bg12.jpg"/></div>
            <div class="txt_list_btn font14">切换LOGO</div>
          </div>
        </div>
      </div>
    </div>

    <div class="RechargeRecord" v-show="RechargeRecordShow">
      <div class="RechargeRecord_content">
        <div class="RechargeRecord_content_title">
          <div class="content_title_left">充值记录</div>
          <div class="content_title_close" @click="RechargeRecordShow = !RechargeRecordShow"><i class="el-icon-close"></i></div>
        </div>
        <div class="RechargeRecord_content_table">
          <div class="content_table_list">
            <div class="table_list_li">订单号</div>
            <div class="table_list_li">订单类型</div>
            <div class="table_list_li">付款方式</div>
            <div class="table_list_li">订单金额(元)</div>
            <div class="table_list_li">付费时间</div>
          </div>

          <div class="content_table_list"
                v-for="(item, index) in LogoRechargeRecord"
                :key="index"
          >
            <div class="table_list_li">{{ item.order_number }}</div>
            <div class="table_list_li">{{ item.name }}</div>
            <div class="table_list_li">{{ item.payment_method }}</div>
            <div class="table_list_li">{{ item.total_amount }}</div>
            <div class="table_list_li">{{ item.pay_time }}</div>
          </div>

        </div>
      </div>
    </div>

    <!-- 充值弹窗 -->
    <logoRechargeWindow v-if="rechargeShow" @close="rechargeShow = false"
                        @rechargePaySuccess="handlePaySuccess"></logoRechargeWindow>

  </div>
</template>
<script>
import {MessageBox, Message} from 'element-ui';
import logoRechargeWindow from "@c/common/logoRechargeWindow/logoRechargeWindow";

export default {
  name: "header",
  data() {
    return {
      rechargeShow: false,
      RechargeRecordShow: false,
      WenJuan: true,
      adShow: false,
      ClickLogoShow: false,
      GenerateManagementWindowActive: false,
      adInfo: [],
      //logo充值记录
      LogoRechargeRecord: [],
      leftLinks: [
        {
          to: '/ailogo/EnterBrand/EnterBrand',
          baseText: 'LOGO生成',
          alt: 'logo',
          icon: require('@/assets/ailogo/img2/s1.svg'), // 确保路径正确
          iconActive: require('@/assets/ailogo/img2/s1on.svg'),
          rightGroups: [
            {
              id: 'group1',
              links: [
                {
                  to: '/ailogo/EnterBrand/EnterBrand',
                  baseText: '自由创作',
                  alt: 'logo',
                  icon: require('@/assets/ailogo/img/s2.svg'),
                  iconActive: require('@/assets/ailogo/img/s2on.svg'),
                  childsubLinks: [ // 子链接，仅用于逻辑匹配
                    {
                      to: '/ailogo/FreeCreation/FreeCreation',
                    },
                    {
                      to: '/ailogo/FreeCreation/StyleColor',
                    },
                    {
                      to: '/ailogo/FreeCreation/FreeCreationKeyword',
                    },
                  ],
                },
                // {
                //   to: '/ailogo/LetterLogo/LetterLogo',
                //   baseText: '字母LOGO',
                //   alt: 'logo',
                //   icon: require('@/assets/ailogo/img/s3.svg'),
                //   iconActive: require('@/assets/ailogo/img/s3on.svg'),
                //   childsubLinks: [ // 子链接，仅用于逻辑匹配
                //     {
                //       to: '/ailogo/LetterLogo/Color',
                //     },
                //     {
                //       to: '/ailogo/LetterLogo/LetterLogoKeyword',
                //     },
                //   ],
                // },
                // {
                //   to: '/ailogo/SameCreation/SameCreation',
                //   baseText: '同款创作',
                //   alt: 'logo',
                //   icon: require('@/assets/ailogo/img/s4.svg'),
                //   iconActive: require('@/assets/ailogo/img/s4on.svg'),
                //   childsubLinks: [ // 子链接，仅用于逻辑匹配
                //     {
                //       to: '/ailogo/SameCreation/SameCreationKeyword',
                //     },
                //   ],
                // },
              ],
            },
          ],
        },
        {
          to: '/ailogo/LogoCenter/FreeCreationCenter',
          baseText: '创作记录',
          alt: 'logo',
          icon: require('@/assets/ailogo/img2/s2.svg'),
          iconActive: require('@/assets/ailogo/img2/s2on.svg'),
          rightGroups: [
            {
              id: 'group2',
              links: [
                {
                  to: '/ailogo/LogoCenter/FreeCreationCenter',
                  baseText: '自由创作',
                  //count: 25,
                  alt: 'logo',
                  icon: require('@/assets/ailogo/img/s2.svg'),
                  iconActive: require('@/assets/ailogo/img/s2on.svg'),
                },
                // {
                //   to: '/ailogo/LogoCenter/LetterLogoCenter',
                //   baseText: '字母LOGO',
                //   count: 2,
                //   alt: 'logo',
                //   icon: require('@/assets/ailogo/img/s3.svg'),
                //   iconActive: require('@/assets/ailogo/img/s3on.svg'),
                // },
                // {
                //   to: '/ailogo/LogoCenter/SameCreationCenter',
                //   baseText: '同款创作',
                //   count: 5,
                //   alt: 'logo',
                //   icon: require('@/assets/ailogo/img/s4.svg'),
                //   iconActive: require('@/assets/ailogo/img/s4on.svg'),
                // },
                {
                  to: '/ailogo/LogoCenter/Downloaded',
                  baseText: '矢量印刷版',
                  //count: 5,
                  alt: 'logo',
                  icon: require('@/assets/ailogo/img/s6.svg'),
                  iconActive: require('@/assets/ailogo/img/s6on.svg'),
                },
              ],
            },
          ],
        },
        {
          to: '/ailogo/GenerateManagement/LogoProperty',
          baseText: 'Vi资产',
          alt: 'logo',
          icon: require('@/assets/ailogo/img2/s3.svg'),
          iconActive: require('@/assets/ailogo/img2/s3on.svg'),
          rightGroups: [
            {
              id: 'group3',
              links: [
                // {
                //   to: '/ailogo/GenerateManagement/LogoProperty',
                //   baseText: 'Vi资产',
                //   alt: 'logo',
                //   icon: require('@/assets/ailogo/img/s13.svg'),
                //   iconActive: require('@/assets/ailogo/img/s13on.svg'),
                // }
              ],
            },
          ],
        },
      ],
    };
  },
  components: {
    logoRechargeWindow
  },
  mounted() {
    // 请求用户信息接口
    // this.fetchMemberInfo();

    // 初始化 ClickLogoShow
    this.updateClickLogoShow(this.currentPath);
  },
  computed: {
    currentPath() {
      return this.$route.path;
    },
    currentLeftLink() {
      let link = this.leftLinks.find(link =>
          link.rightGroups.some(group =>
              group.links.some(l =>
                  this.isPathMatch(l.to) ||
                  (l.childsubLinks && l.childsubLinks.some(sl => this.isPathMatch(sl.to)))
              )
          )
      );
      if (link == null) {
        link = this.leftLinks.find(l => this.isPathMatch(l.to))

      }
      return link || null;
    },
  },
  created() {
    if (this.$store.getters.isLogin) {
      this.getLogoRechargeLog();
    }
    // this.fetchCounts();
  },
  watch: {
    '$route.path'(newPath) {
      this.updateClickLogoShow(newPath);
    },
    leftLinks: {
      handler(newLinks) {
        this.updateClickLogoShow(this.currentPath);
      },
      deep: true
    }
  },
  methods: {
    //获取logo充值记录
    getLogoRechargeLog() {
      this.axios.get('/api/LogoChoice/getLogoRechargeLog').then(res => {
        if (res.code === 1) {
          this.LogoRechargeRecord = res.result;
        } else {
          console.error('获取logo充值记录失败:', res.msg);
        }
      }).catch(err => {
        console.error('获取logo充值记录时发生错误:', err);
      });
    },
    handlePaySuccess() {
      this.$emit('paySuccess'); // 通知父组件
    },
    // 更新ClickLogoShow的状态
    updateClickLogoShow(path) {
      // const group3Link = this.leftLinks.find(leftLink =>
      //   leftLink.rightGroups.some(group => group.id === 'group3')
      // );
      //
      // if (group3Link) {
      //   const group3 = group3Link.rightGroups.find(group => group.id === 'group3');
      //   const isGroup3Active = group3.links.some(link => this.isPathMatch(link.to));
      //   this.ClickLogoShow = isGroup3Active;
      // } else {
      //   this.ClickLogoShow = false;
      // }
    },
    GenerateManagementWindowClass() {
      this.GenerateManagementWindowActive = !this.GenerateManagementWindowActive
    },
    isPathMatch(path) {
      return this.currentPath === path || this.currentPath.startsWith(path + '/');
    },
    isActive(link) {
      if (this.isPathMatch(link.to)) {
        return true;
      }
      if (link.childsubLinks) {
        return link.childsubLinks.some(subLink => this.isPathMatch(subLink.to));
      }
      return false;
    },
    isLeftLinkActive(link) {
      if (this.currentLeftLink && this.currentLeftLink.to === link.to) {
        return true;
      }
      return link.rightGroups.some(group =>
          group.links.some(l =>
              l.childsubLinks ? l.childsubLinks.some(sl => this.isPathMatch(sl.to)) : false
          )
      );
    },
    // fetchCounts() {
    //   // 示例 API 请求
    //   axios.get('/api/getNavigationCounts')
    //       .then(response => {
    //         const counts = response.data;
    //         this.leftLinks.forEach(link => {
    //           if (link.baseText === '创作记录') {
    //             link.rightGroups.forEach(group => {
    //               group.links.forEach(subLink => {
    //                 switch (subLink.baseText) {
    //                   case '自由创作':
    //                     subLink.count = counts.freeCreation || 0;
    //                     break;
    //                   case '字母LOGO':
    //                     subLink.count = counts.letterLogo || 0;
    //                     break;
    //                   case '同款创作':
    //                     subLink.count = counts.sameCreation || 0;
    //                     break;
    //                   case '已下载':
    //                     subLink.count = counts.downloaded || 0;
    //                     break;
    //                   default:
    //                     break;
    //                 }
    //               });
    //             });
    //           }
    //         });
    //       })
    //       .catch(error => {
    //         console.error('获取导航计数失败:', error);
    //       });
    // },
    getRightLinks(leftLink) {
      if (leftLink && leftLink.rightGroups) {
        return leftLink.rightGroups;
      }
      return [];
    },
    selectIndex(index) {
      this.selectedIndex = index;
    },
    showWindow() {
      this.rechargeShow = true;
    },
    openNewWindow() {
      window.open('/', '_blank');
    },
    logout() {
      MessageBox.confirm(`确定要退出登录吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '退出成功!'
        });
        this.axios.get('/api/member/logout').then(res => {
          if (res.code === 1) {
            localStorage.removeItem('token')
            localStorage.removeItem('memberInfo')
            this.$store.commit('setLogin', false)
            this.$store.commit('setMemberInfo', {})
            this.$router.push({path: '/ailogoLogin'})
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消退出'
        });
      });
    },
    toLogin() {
      this.$router.push({path: '/ailogoLogin'})
    },
    /*fetchMemberInfo() {
      this.axios.get('/api/member/getInfo').then(res => {
        if (res.code === 1) {
          localStorage.setItem('memberInfo', JSON.stringify(res.result));
          this.$store.commit('setMemberInfo', res.result);
        } else {
          console.error('获取用户信息失败:', res.msg);
        }
      }).catch(err => {
        console.error('请求用户信息时发生错误:', err);
      });
    },*/

    //获取自由创作数量
    getFreeCreateNum() {
      this.axios.get('/api/LogoChoice/getFreeCreateNum').then(res => {
        if (res.code === 1) {
          this.freeCreateNum = res.result;
        } else {
          console.error('获取自由创作数量失败:', res.msg);
        }
      }).catch(err => {
        console.error('获取自由创作数量时发生错误:', err);
      });
    },

  }
}
</script>

<style>
@import "header.css";
/* 其他样式 */
</style>